import styled from "styled-components";

import { Text } from "/component/base";
import { layout } from "/styles";

export const Subtitle = styled(Text)(layout.padding("skip", "skip", "gutter"));
